<button class="btn btn-secondary btn-action ml-3" [ngClass]="cancelAdditionalClass" type="reset" (click)="onCancel()" [disabled]="cancelBtnDisable">
    {{ cancelBtnTitle | translate}}
</button>
<button class="btn btn-primary btn-action" [ngClass]="saveAdditionalClass" type="submit" (click)="onSave()" [disabled]="saveBtnDisable">
    {{ saveBtnTitle | translate}}
</button>
